import sanitizeHtml from 'sanitize-html';
import isNil from 'lodash/isNil';
import omit from 'lodash/omit';

import { __t, applyTranslations } from 'utils/language';

import type {
  Report
} from 'modules/insights/reports/types';

applyTranslations(require('../shared/insights-reports-shared.i18n.json'));

const SHARED_MSG_KEY = 'insights_reports_shared';

export const COLLABARY = 'collabary';
export const INSTAGRAM = 'instagram';
export const REPORT = 'report';
export const QUERY = 'query';
export const ANALYSIS = 'analysis';
export const CREATE = 'create';
export const EDIT = 'edit';
export const DUPLICATE = 'duplicate';
export const DELETE = 'delete';
export const FIXED_TO_TOP = 'fixed-to-top';
export const UNTITLED = __t(`${SHARED_MSG_KEY}.labels.untitled`);

export const REPORT_SAVED_TIMEOUT = 2000;
export const TIMEFRAME_NUM_YEARS_IN_FUTURE = 5;

export const MODAL_META_CHAR_LIMITS = {
  name: 65,
  description: 200
};

export const KPI_OPTIONS_INSTAGRAM = {
  contentCreators: 'content_creators',
  engagements: 'engagements',
  followers: 'followers',
  impressions: 'impressions',
  posts: 'posts',
  reach: 'reach'
};

export const GRAPH_KPI_OPTIONS_INSTAGRAM = KPI_OPTIONS_INSTAGRAM;
export const TOP_CREATORS_KPI_OPTIONS_INSTAGRAM = omit(KPI_OPTIONS_INSTAGRAM, ['contentCreators']);

const SANITIZE_HTML_CONFIG = {
  allowedTags: ['strong']
};

export const DATA_COLUMNS_INSTAGRAM = [
  'contentCreators',
  'followers',
  'posts',
  'impressions',
  'reach',
  'engagements',
  'engagementRate'
];

const allowedHashtagValues = /[^a-z\u00E0-\u00FC&0-9_.]/ig;
const allowedChannelValues = /[^a-z0-9_.]/ig;
const numbersOnly = /[^0-9]+/g;

export const sanitizeHashtagValue = (
  value: string
): string => (
  value.replace(allowedHashtagValues, '')
);

export const sanitizeChannelValue = (
  value: string
): string => (
  value.replace(allowedChannelValues, '')
);

export const sanitizeMessage = (
  message: string
): string => (
  sanitizeHtml(message, SANITIZE_HTML_CONFIG)
);

export const allowNumbersOnly = (
  value: string
): string => (
  value.replace(numbersOnly, '')
);

export const isReadyForAnalysis = (
  report: Report
): boolean | undefined | null => {
  if (isNil(report)) {
    return null;
  }

  const requirements = [
    {
      name: 'startDate',
      test: !isNil(report.startDate)
    },
    {
      name: 'endDate',
      test: !isNil(report.endDate)
    }
  ];

  const checks = requirements.filter(requirement => (
    requirement.test
  ));

  return checks.length === requirements.length;
};
